<template>
  <el-select
    v-model="newValue"
    clearable
    size="small"
    placeholder="请选择"
    @change="handleChange(newValue)"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"/>
  </el-select>
</template>

<script>
    export default {
        name: "SelectBabel",
        props: {
            value: Number,
        },
        data() {
            return {
                newValue: this.value,
                options: [{ value: 0, label: '未标记' }, { value: 1, label: '已标记' }],
            };
        },
      watch: {
          value(vl) { this.newValue = vl; },
          newValue(vl) { this.$emit('update:value', vl); },
      },
        methods: {
          handleChange(value) {
            this.$emit('change', value);
          },
        },
    };
</script>

<style scoped>

</style>
